import React, { useState } from "react";
import DemoExecution from "../components/DemoExecution";
import Log from "../components/Log";
import Header from "../components/Header";
import { getCurrentDate } from "../helpers/dateHelper";
import BuildkiteStatus from "../components/BuildkiteStatus";
import { isDone } from "../helpers/pipelineStatusHelper";

const Home = () => {
  const [messages, setMessages] = useState([]);
  const [currentPipelineStatus, setCurrentPipelineStatus] = useState("none");
  const [executionTime, setExecutionTime] = useState(0);
  const [executionEndedTime, setExecutionEndedTime] = useState(0);

  const updateStatus = (status, time) => {
    if (status !== currentPipelineStatus) {
      setCurrentPipelineStatus(status);
      setExecutionTime(time);

      if (isDone(status)) {
        setExecutionEndedTime(Date.now());
      }
    }
  };

  const logMessage = (message) => {
    message.timeStamp = getCurrentDate();

    setMessages((oldArray) => [...oldArray, message]);
  };

  const clearLog = () => {
    setMessages([]);
  };

  return (
    <div className="container" style={{ marginBottom: "50px" }}>
      <Header />
      <div className="container">
        <div className="row">
          <DemoExecution
            onLogMessage={logMessage}
            onUpdateStatus={updateStatus}
          />
          <div className="col-md">
            <BuildkiteStatus
              currentPipelineStatus={currentPipelineStatus}
              executionStarted={executionTime}
              executionEndedTime={executionEndedTime}
            />
            <Log messages={messages} onClearLog={clearLog} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
